import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { User } from 'src/generated/graphql';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

import { NW_PRIVACY_POLICY_URL } from 'src/app/shared/constans';

@Injectable({
    providedIn: 'root'
})
export class AuthUiHelperService {

    private readonly _currentUserSource = new BehaviorSubject<CurrentUser>(new CurrentUser({}, false));
    readonly currentUser$ = this._currentUserSource.asObservable();

    private BASE_URL: string;

    constructor(
        private httpClient: HttpClient,
        private readonly authService: AuthService
        ) {
        this.BASE_URL = environment['restApiUrl'];
        this._setCurrentUser();

        // TODO how to make logout more gracefully without forbidden message
        // this.authService.fullyAuthenticated().then(authenticated => {
        //     if (authenticated)
        //         this._setCurrentUser();
        // });
    }
    
    getYear(): {year: string} {
        return {year:`${new Date().getFullYear()}`}
    }

    /**
     * Get current user (latest value) without subscribing
     * @returns 
     */
    getCurrentUser(): CurrentUser {
        return this._currentUserSource.getValue();
    }

    /**
     * Should be called from a component / service that just performed an authentication process
     * Lets this service (re)fetch currentUser and push update to all other subscribers
     */
    userDidAuthenticate(): void {
        this._setCurrentUser();
    }

    /**
     * Fetch current user over HTTP and tell subscribers
     */
    private _setCurrentUser(): void {
        //TODO add rxjs catchError
        this.httpClient.get<User>(
            `${this.BASE_URL}/auth/currentUser`).pipe(
                    map((user) => new CurrentUser(user, true))
                ).subscribe(
                    currentUser => {
                        console.log("Resolved current user");
                        this._currentUserSource.next(currentUser)
                    },
                    error => { 
                        if (error instanceof HttpErrorResponse) {
                            console.log("Unable to resolve current user", error);
                        } else {
                            console.error("Unable to resolve current user", error)
                        } 
                    }
            );
    }

    getPrivacyPolicyUrl(): string {
        return NW_PRIVACY_POLICY_URL;
    }
}

export class CurrentUser {

    public authenticated:boolean;

    //FIXME actually this instance is an AuthUser and not a user. For example it is missing email property and has username property!
    public user:User;

    constructor(user:User, authenticated:boolean) {
        this.user = user;
        this.authenticated = authenticated;
    }

    getRole():string {
        return this.user.role;
    }

    /**
     * Returns current email domain
     */
    getDomain():string {
        return (this.user as any).username.split("@")[1]
    }

    // Actual instance of an AuthUser
    isSameUser(user:User): boolean {
        return this.user.id === user.id;
    }

    hasRole(roles:string[]): boolean {
        return roles.includes(this.getRole());
    }

    hasNotRole(roles:string[]): boolean {
        return !this.hasRole(roles);
    }
}
